module.exports = __webpack_public_path__ + "img/icon-arrow-down-black.70b8bbcd.svg";